import React from "react";
import { Typography, Box } from "@material-ui/core";

import { AgreementInfo } from "../../../api/services";
import { DateRangeLabel } from "./DateRangeLabel";
import { useAgreement } from "../hooks/useAgreement";
import { AgreementTariff } from "./AgreementTariff";

export const Agreement: React.FC<{
  agreement: AgreementInfo;
}> = ({ agreement }) => {
  const { name: agreementName, fromDttm } = agreement;
  const { rates, charge, endDttm, taxDescription } = useAgreement(agreement);

  return (
    <Box
      display="flex"
      data-testid="MeterPoint__Agreement"
      flexDirection="column"
    >
      <Typography variant="subtitle1">{agreementName}</Typography>
      <DateRangeLabel title="Agreement dates" from={fromDttm} to={endDttm} />
      <AgreementTariff rates={rates} charge={charge} mb={2} mt={2.5} />
      {rates.length > 0 || charge != null ? (
        <Typography component="span" variant="caption" color="textPrimary">
          {taxDescription}
        </Typography>
      ) : null}
    </Box>
  );
};
